import { useTranslation } from 'react-i18next';
import StepTab from '../../components/StepperTabs/StepTab';
import StepperTabs from '../../components/StepperTabs/StepperTabs';
import HeadTittle from '../../components/HeadTittle';
import ResourcesTab from './Subcomponents/ResourcesTab';
import { permissionObj } from '../../Helpers/permission';
import ButtonAction from '../../components/buttons/ButtonAction';
import { AddIcon, TrashOutlineIcon } from '../../components/buttons/IconButtons';
import routes from '../../Routes/routes';
import DeleteModal from "../Modals/DeleteModal";
import TemplatesCards from "./Subcomponents/TemplatesCards";
import CardDesignerPanelApp from "./Functionality/CardDesignerPanelApp";
import {TAB_PERMISSION_CARD_DESIGNER, TABS_CARD_DESIGNER} from "./Model/Model";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CardDesignerPanel = () => {
    const { t } = useTranslation();
    const {
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        view,
        option,
        DEV,
        permission,
        navigate,
        addResourceShow,
        setAddResourceShow,
        selectedList,
        setSelectedList,
        showDeleteModal,
        setShowDeleteModal,
        modified,
        setModified,
        setSearch,
        searchElement,
        setSearchElement,
        isAllChecked,
        setIsAllChecked,
        deleteSelected,
        setBodyForExport,
        simpleSearch,
        setSimpleSearch,
        permissionButtons
    } = CardDesignerPanelApp();

     if(!DEV && !permission?.includes(permissionObj.WEB_RESOURCES_READ) && !permission?.includes(permissionObj.WEB_CARD_DESIGNER_READ) )
         navigate(routes.forbidden);
    return (
        <>
            <HeadTittle name={t('card_designer')}>
                <div className='col-12 d-flex justify-content-end gap-2 flex-wrap mb-4'>
                    {permissionButtons(TAB_PERMISSION_CARD_DESIGNER().CREATE) &&
                        <ButtonAction
                            id={activeStep === TABS_CARD_DESIGNER.TEMPLATES.INDEX ? 'btn_cdp_create_template' : 'btn_cdp_create_resource'}
                            name='create'
                            className='btn-icon-add'
                            Icon={AddIcon}
                            onClick={() => {
                                if (activeStep === TABS_CARD_DESIGNER.TEMPLATES.INDEX) {
                                    navigate(routes.cardDesigner.create);
                                }else{
                                    setAddResourceShow(true);
                                }
                            }}
                        />
                    }

                    {permissionButtons(TAB_PERMISSION_CARD_DESIGNER().DELETE) &&
                        <ButtonAction
                            id={activeStep === TABS_CARD_DESIGNER.TEMPLATES.INDEX ? 'btn_cdp_delete_template' : 'btn_cdp_delete_resource'}
                            name='delete'
                            className='btn-icon-delete'
                            Icon={TrashOutlineIcon}
                            disabled={selectedList?.length <= 0}
                            onClick={() => setShowDeleteModal(true)}
                        />
                    }
                </div>
            </HeadTittle>

            <StepperTabs
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
                onlyTab={true}
            >
                <StepTab index={TABS_CARD_DESIGNER.TEMPLATES.INDEX} activeStep={activeStep}>
                    { activeStep === TABS_CARD_DESIGNER.TEMPLATES.INDEX &&
                    <TemplatesCards
                        view={view}
                        option={option}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        modified={modified}
                        setModified={setModified}
                        setSearch={setSearch}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        isAllChecked={isAllChecked}
                        setIsAllChecked={setIsAllChecked}
                        setBodyForExport={setBodyForExport}
                        simpleSearch={simpleSearch}
                        setSimpleSearch={setSimpleSearch}
                    />
                    }
                </StepTab>
                <StepTab index={TABS_CARD_DESIGNER.RESOURCES.INDEX} activeStep={activeStep}>
                    { activeStep === TABS_CARD_DESIGNER.RESOURCES.INDEX &&
                    <ResourcesTab
                        view={view}
                        option={option}
                        setBodyForExport={setBodyForExport}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        isAllChecked={isAllChecked}
                        setIsAllChecked={setIsAllChecked}
                        modified={modified}
                        setModified={setModified}
                        setSearch={setSearch}
                        simpleSearch={simpleSearch}
                        setSimpleSearch={setSimpleSearch}
                        addResourceShow={addResourceShow}
                        setAddResourceShow={setAddResourceShow}
                    />
                    }
                </StepTab>
            </StepperTabs>


            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onClickFn={() => deleteSelected(selectedList)}
                isReset={setSelectedList}
                isAllReset={setIsAllChecked}
                data={selectedList}
                title_modal={t('delete')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={activeStep === TABS_CARD_DESIGNER.TEMPLATES.INDEX ? t('template'):  t('resource')}
            />
        </>
    );
};
export default CardDesignerPanel;
